import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface SimpleDropdownProps {
  items?: any[];
  value: string | null;
  onChange: (value: string | null) => void;
  displayField?: string;
  valueField?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
}

const SimpleDropdown: React.FC<SimpleDropdownProps> = ({
  items = [],
  value,
  onChange,
  displayField = 'name',
  valueField = 'id',
  placeholder = 'Select...',
  disabled = false,
  className = '',
  required = false,
  error
}) => {

  return (
    <div className={`relative ${className}`}>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={disabled}
        className={`
          relative w-full bg-white border rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default
          focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm
          disabled:bg-gray-50 disabled:cursor-not-allowed appearance-none
          ${error ? 'border-red-500' : 'border-gray-300'}
        `}
        required={required}
      >
        <option value="">{placeholder}</option>
        {items.map((item) => (
          <option key={item[valueField]} value={item[valueField]}>
            {item[displayField]}
          </option>
        ))}
      </select>
      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <ChevronDownIcon className="h-5 w-5 text-gray-400" />
      </span>
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
};

export default SimpleDropdown;